module.exports = __webpack_public_path__ + "static/img/QRcode-1.b9953fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/QRcode-1.jpg
// module id = L44l
// module chunks = 8